export const ERROR_HISTORY_GRID_TYPE = {
    ALL: 'all',
    SITE: 'site',
};
export const ERROR_LEVEL = {
    FAULT: 'FAULT',
    WARNING: 'WARNING',
    ALARM: 'ALARM',
};
export const ERROR_LEVEL_DISPLAY_TEXT = {
    FAULT: 'fault',
    WARNING: 'warning',
    ALARM: 'alarm',
};
export const ERROR_LEVEL_SELECTOR_OPTIONS = [
    { code: ERROR_LEVEL_DISPLAY_TEXT.FAULT, name: 'device.fault' },
    { code: ERROR_LEVEL_DISPLAY_TEXT.WARNING, name: 'device.warning' },
    { code: ERROR_LEVEL_DISPLAY_TEXT.ALARM, name: 'common.alarm' },
];
export const ERROR_PREFIX = {
    /** Grid 에러 코드 (Dashboard - Grid) */
    GRID: 'G',
    /** Hybrid Inverter - PV 모듈 에러 코드 (Dashboard - Solar) */
    SOLAR: 'S',
    /** Micro Inverter 에러 코드 (Dashboard - Solar) */
    MICRO_INVERTER: 'M',
    /** AC Combiner 에러 코드 (Dashboard - AC Combiner) */
    AC_COMBINER: 'A',
    /** DC Optimizer 에러 코드 (DC Optimizer GEN2 - deprecated) */
    DC_OPTIMIZER: 'O',
    /** ESS - Inverter 에러 코드 (Dashboard - ESS) */
    INVERTER: 'P',
    /** ESS - BDC 에러 코드 (Dashboard - ESS) */
    BDC: 'D',
    /** ESS - EMS 또는 G4 HUB - EMS 에러 코드 (Dashboard - ESS) */
    EMS: 'E',
    /** ESS - BMS 에러 코드 (Dashboard - ESS) */
    BMS: 'B',
    /** HUB 에러 코드 (Dashboard - HUB) */
    HUB: 'H',
    /** Cloud 자체 정의 에러 코드 */
    CLOUD: 'C',
};
export const ERROR_STATUS_TYPE = {
    ERROR: 'E',
    WARNING: 'W',
};
export const ERROR_RESOLVED_FILTER = {
    CURRENT: 'current',
    RESOLVED: 'resolved',
};
export const ERROR_HISTORY_DOWNLOAD_LIST_SIZE = 1000;
export const ERROR_TYPE = {
    /** Admin이 조회 가능한 Error */
    MINOR: 'MINOR',
    /** Installer가 조회 가능한 Error */
    MAJOR: 'MAJOR',
};
